import { render, staticRenderFns } from "./SpFourModule1.vue?vue&type=template&id=450d71e4&scoped=true"
import script from "./SpFourModule1.vue?vue&type=script&lang=js"
export * from "./SpFourModule1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d71e4",
  null
  
)

export default component.exports